import {Component, Input, OnInit} from '@angular/core';
import {Order} from "../../models/shop/order.model";
import {CommonUtils} from "../../utils/common";
import {ModalController} from "@ionic/angular";

@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.component.html',
  styleUrls: ['./order-details.component.scss'],
})
export class OrderDetailsComponent implements OnInit {

  @Input() order: Order;
  @Input() paymentMethodsList;
  @Input() isGeneralAdmin;
  @Input() title;
  status: string;
  settlementStatus: any;


  constructor(public commonUtils: CommonUtils,
              private modalController: ModalController) {

  }

  ngOnInit() {
    console.log(this.order)
    this.status = this.commonUtils.getOrderStatusLabel(this.order.statusId);
    this.settlementStatus = this.commonUtils.getSettlementStatusLabel(this.order.settlementStatus);

  }

  getPaymentMethodName() {
    const paymentMethod = this.paymentMethodsList.filter((method) => {
      return method.id.toString() === this.order.paymentGatewayId;
    })[0];
    return paymentMethod ? paymentMethod.name : 'brak danych';
  }

  onClose() {
    this.modalController.dismiss();
  }

  translateType(reservationType: string) {
    return this.commonUtils.getReservationTypeLabel(reservationType);
  }
}



